/* ==================================================================
   Pluffi — Calendrier des promotions (fuseau US Eastern)
   ------------------------------------------------------------------
   Calcule la promo en cours selon la date à New York et met à jour
   automatiquement les éléments du thème qui portent ces attributs :

     data-promo-name                 → affiche le nom de la promo
     data-promo-text="… {name} …"    → texte avec {name} et {end}
     data-promo-countdown            → compte à rebours jusqu'à la fin
     data-promo-only="key,key"       → visible seulement pendant ces promos
     data-promo-hide="key,key"       → masqué pendant ces promos

   Ajoute aussi sur <html> : data-promo="key" et la classe promo-key.

   Tester une date : ajouter ?promo_date=2026-11-27 à l'URL.
   En JavaScript : window.PluffiPromo.current
   ================================================================== */

(function () {
  'use strict';

  var TIMEZONE = 'America/New_York';

  /* ----------------------------------------------------------------
     Dates de Prime Day (annoncées par Amazon ~3 semaines avant).
     À compléter chaque année. Sans dates, la promo est ignorée.
     ---------------------------------------------------------------- */
  var PRIME_DAY = {
    2026: ['06-23', '06-26'],
    // 2027: ['07-13', '07-16'],
  };

  /* ----------------------------------------------------------------
     SAISONS DE FOND : il y a toujours une promo. Chacune dure
     jusqu'au début de la suivante. Dates au format 'MM-JJ' ou calculées.
     ---------------------------------------------------------------- */
  var SEASONS = [
    {key: 'winter-sale', name: 'Winter Sale', start: '01-01'},
    {key: 'spring-sale', name: 'Spring Sale', start: '03-18'},
    {key: 'summer-sale', name: 'Summer Sale', start: function (h) { return addDays(h.memorialDay, 1); }},
    {key: 'early-fall-sale', name: 'Early Fall Sale', start: function (h) { return addDays(h.laborDay, 1); }},
    {key: 'fall-deal-days', name: 'Fall Deal Days', start: '10-01'},
    {key: 'halloween-sale', name: 'Halloween Sale', start: '10-15'},
    {key: 'black-friday-early-access', name: 'Black Friday Early Access', start: '11-01'},
    {key: 'black-friday', name: 'Black Friday', start: function (h) { return h.blackFriday; }},
    {key: 'cyber-monday', name: 'Cyber Monday', start: function (h) { return h.cyberMonday; }},
    {key: 'cyber-week', name: 'Cyber Week', start: function (h) { return addDays(h.cyberMonday, 1); }},
    {key: 'holiday-sale', name: 'Holiday Sale', start: function (h) { return addDays(h.cyberMonday, 8); }},
    {key: 'year-end-sale', name: 'Year-End Sale', start: '12-26'},
  ];

  /* ----------------------------------------------------------------
     TEMPS FORTS : passent devant la saison de fond pendant leurs dates
     (début et fin inclus). Si deux se chevauchent, le plus court gagne.
     ---------------------------------------------------------------- */
  var EVENTS = [
    {key: 'valentines-day-sale', name: "Valentine's Day Sale", start: '01-26', end: '02-14'},
    {key: 'st-patricks-lucky-sale', name: "St. Patrick's Lucky Sale", start: '03-10', end: '03-17'},
    {key: 'easter-sale', name: 'Easter Sale', start: function (h) { return addDays(h.easter, -6); }, end: function (h) { return h.easter; }},
    {key: 'earth-day-sale', name: 'Earth Day Sale', start: '04-20', end: '04-22'},
    {key: 'mothers-day-sale', name: "Mother's Day Sale", start: function (h) { return addDays(h.mothersDay, -14); }, end: function (h) { return h.mothersDay; }},
    {key: 'memorial-day-sale', name: 'Memorial Day Sale', start: function (h) { return addDays(h.memorialDay, -10); }, end: function (h) { return h.memorialDay; }},
    {key: 'fathers-day-sale', name: "Father's Day Sale", start: function (h) { return addDays(h.fathersDay, -10); }, end: function (h) { return h.fathersDay; }},
    {key: 'summer-deal-days', name: 'Summer Deal Days', start: function (h) { return primeDay(h.year, 0); }, end: function (h) { return primeDay(h.year, 1); }},
    {key: '4th-of-july-sale', name: '4th of July Sale', start: '06-27', end: '07-05'},
    {key: 'back-to-school', name: 'Back to School', start: '07-25', end: '08-20'},
    {key: 'labor-day-sale', name: 'Labor Day Sale', start: function (h) { return addDays(h.laborDay, -10); }, end: function (h) { return h.laborDay; }},
  ];

  /* ----------------------------------------------------------------
     TEXTES D'APPS : éléments dont le texte est remplacé automatiquement
     par le nom de la promo (même si l'app les affiche ou les rafraîchit
     après le chargement). uppercase: true → LABOR DAY SALE
     ---------------------------------------------------------------- */
  var TEXT_TARGETS = [
    {selector: '.kaching-bundles__block-title', uppercase: true},
  ];

  /* ================================================================
     Rien à modifier en dessous
     ================================================================ */

  var DAY_MS = 86400000;

  // Une "journée" = objet Date à minuit UTC représentant une date calendaire.
  function day(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function addDays(date, n) { return new Date(date.getTime() + n * DAY_MS); }

  function nthWeekday(y, m, weekday, n) {
    var first = day(y, m, 1);
    return addDays(first, ((weekday - first.getUTCDay() + 7) % 7) + (n - 1) * 7);
  }

  function lastWeekday(y, m, weekday) {
    var last = day(y, m + 1, 0);
    return addDays(last, -((last.getUTCDay() - weekday + 7) % 7));
  }

  function easterSunday(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    return day(y, month, ((h + l - 7 * m + 114) % 31) + 1);
  }

  function primeDay(y, index) {
    var dates = PRIME_DAY[y];
    return dates ? parseMonthDay(y, dates[index]) : null;
  }

  function parseMonthDay(y, str) {
    var p = str.split('-');
    return day(y, Number(p[0]), Number(p[1]));
  }

  var holidayCache = {};
  function holidays(y) {
    if (!holidayCache[y]) {
      var thanksgiving = nthWeekday(y, 11, 4, 4);
      holidayCache[y] = {
        year: y,
        easter: easterSunday(y),
        mothersDay: nthWeekday(y, 5, 0, 2),
        memorialDay: lastWeekday(y, 5, 1),
        fathersDay: nthWeekday(y, 6, 0, 3),
        laborDay: nthWeekday(y, 9, 1, 1),
        blackFriday: addDays(thanksgiving, 1),
        cyberMonday: addDays(thanksgiving, 4),
      };
    }
    return holidayCache[y];
  }

  function resolve(value, h) {
    if (!value) return null;
    return typeof value === 'function' ? value(h) : parseMonthDay(h.year, value);
  }

  // Promo active pour une journée donnée.
  function promoOn(date) {
    var h = holidays(date.getUTCFullYear());
    var t = date.getTime();

    var best = null;
    var bestLength = Infinity;
    EVENTS.forEach(function (ev) {
      var s = resolve(ev.start, h);
      var e = resolve(ev.end, h);
      if (!s || !e || t < s.getTime() || t > e.getTime()) return;
      var length = e.getTime() - s.getTime();
      if (length < bestLength) {
        best = ev;
        bestLength = length;
      }
    });
    if (best) return best;

    var season = SEASONS[0];
    var seasonStart = -Infinity;
    SEASONS.forEach(function (s) {
      var start = resolve(s.start, h).getTime();
      if (start <= t && start >= seasonStart) {
        season = s;
        seasonStart = start;
      }
    });
    return season;
  }

  // Décalage (en minutes) du fuseau US à un instant donné.
  function offsetMinutes(instant) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: TIMEZONE, hourCycle: 'h23',
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
    }).formatToParts(instant).forEach(function (p) { parts[p.type] = Number(p.value); });
    var wall = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
    return Math.round((wall - Math.floor(instant.getTime() / 1000) * 1000) / 60000);
  }

  // Minuit (heure US) au début d'une journée, en instant réel.
  function usMidnight(date) {
    var guess = new Date(date.getTime());
    return new Date(guess.getTime() - offsetMinutes(guess) * 60000);
  }

  function todayInUS(now) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: TIMEZONE, year: 'numeric', month: 'numeric', day: 'numeric',
    }).formatToParts(now).forEach(function (p) { parts[p.type] = Number(p.value); });
    return day(parts.year, parts.month, parts.day);
  }

  function computeState(now) {
    var today = todayInUS(now);
    var promo = promoOn(today);

    var start = today;
    for (var i = 1; i < 400 && promoOn(addDays(today, -i)).key === promo.key; i++) start = addDays(today, -i);

    var end = today;
    for (var j = 1; j < 400 && promoOn(addDays(today, j)).key === promo.key; j++) end = addDays(today, j);

    return {
      key: promo.key,
      name: promo.name,
      start: start,                          // premier jour (date calendaire)
      end: end,                              // dernier jour (date calendaire)
      endsAt: usMidnight(addDays(end, 1)),   // instant exact de fin (minuit heure US)
      today: today,
    };
  }

  function formatDay(date) {
    return new Intl.DateTimeFormat('en-US', {timeZone: 'UTC', month: 'short', day: 'numeric'}).format(date);
  }

  var api = {
    promoOn: promoOn,
    computeState: computeState,
    holidays: holidays,
    seasons: SEASONS,
    events: EVENTS,
  };

  if (typeof document === 'undefined') {
    if (typeof module !== 'undefined') module.exports = api;
    return;
  }

  /* --- Navigateur ------------------------------------------------- */

  function getNow() {
    var match = /[?&]promo_date=(\d{4})-(\d{2})-(\d{2})/.exec(window.location.search);
    if (!match) return new Date();
    // Midi à New York le jour demandé, pour tester sans ambiguïté.
    return new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 17));
  }

  function listIncludes(attr, key) {
    return (attr || '').split(',').map(function (s) { return s.trim(); }).indexOf(key) !== -1;
  }

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function renderCountdown(el, state, now) {
    var ms = Math.max(0, state.endsAt.getTime() - now.getTime());
    var total = Math.floor(ms / 1000);
    var format = el.getAttribute('data-promo-countdown') || '{d}d {h}h {m}m {s}s';
    el.textContent = format
      .replace('{d}', Math.floor(total / 86400))
      .replace('{h}', pad(Math.floor((total % 86400) / 3600)))
      .replace('{m}', pad(Math.floor((total % 3600) / 60)))
      .replace('{s}', pad(total % 60));
  }

  function apply(root) {
    var state = api.current;
    root = root || document;
    var html = document.documentElement;

    html.className = html.className.replace(/\bpromo-[\w-]+\b/g, '').trim();
    html.classList.add('promo-' + state.key);
    html.setAttribute('data-promo', state.key);

    root.querySelectorAll('[data-promo-name]').forEach(function (el) {
      el.textContent = state.name;
    });

    root.querySelectorAll('[data-promo-text]').forEach(function (el) {
      el.textContent = el.getAttribute('data-promo-text')
        .split('{name}').join(state.name)
        .split('{end}').join(formatDay(state.end));
    });

    root.querySelectorAll('[data-promo-only]').forEach(function (el) {
      el.classList.toggle('promo-match', listIncludes(el.getAttribute('data-promo-only'), state.key));
    });

    root.querySelectorAll('[data-promo-hide]').forEach(function (el) {
      el.classList.toggle('promo-hidden', listIncludes(el.getAttribute('data-promo-hide'), state.key));
    });

    root.querySelectorAll('[data-promo-countdown]').forEach(function (el) {
      renderCountdown(el, state, getNow());
    });

    document.dispatchEvent(new CustomEvent('pluffi:promo', {detail: state}));
  }

  function refresh(root) {
    api.current = computeState(getNow());
    apply(root);
    watchedRoots.forEach(applyTargets);
  }

  // Compte à rebours : mise à jour chaque seconde, et bascule auto à la promo suivante.
  setInterval(function () {
    var now = getNow();
    if (now.getTime() >= api.current.endsAt.getTime() && !/promo_date=/.test(window.location.search)) {
      refresh();
      return;
    }
    document.querySelectorAll('[data-promo-countdown]').forEach(function (el) {
      renderCountdown(el, api.current, now);
    });
  }, 1000);

  /* --- Mots-clés dans le texte des apps (Kaching, etc.) -----------
     Écrire {promo} ou {PROMO} (majuscules) directement dans l'app :
     le script remplace le mot-clé par le nom de la promo en cours,
     y compris quand l'app affiche ou rafraîchit son contenu plus tard. */

  var TOKEN = /\{promo\}|\[promo\]/gi;

  function replaceTokens(node) {
    if (node.nodeType === 3) {
      var text = node.nodeValue;
      if (!text || text.indexOf('promo') === -1 && text.indexOf('PROMO') === -1) return;
      TOKEN.lastIndex = 0;
      if (!TOKEN.test(text)) return;
      var name = api.current.name;
      node.nodeValue = text.replace(TOKEN, function (match) {
        return match.slice(1, -1) === 'PROMO' ? name.toUpperCase() : name;
      });
      return;
    }
    if (node.nodeType !== 1 && node.nodeType !== 11) return;
    if (node.nodeName === 'SCRIPT' || node.nodeName === 'STYLE' || node.nodeName === 'TEXTAREA') return;

    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(replaceTokens);

    // Apps en Shadow DOM ouvert : on traite et on surveille aussi l'intérieur.
    if (node.querySelectorAll) {
      if (node.shadowRoot) watch(node.shadowRoot);
      node.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) watch(el.shadowRoot);
      });
    }
  }

  // Remplace uniquement le texte, sans toucher aux marqueurs internes de l'app
  // (ex. le <!----> de Kaching), pour ne pas casser son affichage.
  function setOwnText(el, value) {
    var textNode = null;
    for (var i = 0; i < el.childNodes.length; i++) {
      var child = el.childNodes[i];
      if (child.nodeType === 3 && child.nodeValue.trim()) {
        if (textNode) child.nodeValue = '';
        else textNode = child;
      }
    }
    if (!textNode) {
      if (el.children.length) return; // structure inconnue : on ne touche à rien
      el.insertBefore(document.createTextNode(value), el.firstChild);
      return;
    }
    if (textNode.nodeValue !== value) textNode.nodeValue = value;
  }

  function applyTargets(root) {
    if (!root || !root.querySelectorAll) return;
    TEXT_TARGETS.forEach(function (t) {
      var value = t.uppercase ? api.current.name.toUpperCase() : api.current.name;
      root.querySelectorAll(t.selector).forEach(function (el) { setOwnText(el, value); });
    });
  }

  var watchedRoots = [];

  function watch(target) {
    if (watchedRoots.indexOf(target) !== -1) return;
    watchedRoots.push(target);
    replaceTokens(target);
    applyTargets(target);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'characterData') replaceTokens(m.target);
        m.addedNodes && m.addedNodes.forEach(replaceTokens);
      });
      applyTargets(target);
    }).observe(target, {childList: true, subtree: true, characterData: true});
  }

  api.refresh = refresh;
  api.current = computeState(getNow());
  window.PluffiPromo = api;

  function start() {
    apply();
    watch(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Éditeur de thème Shopify : réappliquer quand une section est rechargée.
  document.addEventListener('shopify:section:load', function (e) { apply(e.target); });
})();
